import { render, staticRenderFns } from "./AnketYanitlarSingle.vue?vue&type=template&id=97224622&"
import script from "./AnketYanitlarSingle.vue?vue&type=script&lang=js&"
export * from "./AnketYanitlarSingle.vue?vue&type=script&lang=js&"
import style0 from "./AnketYanitlarSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports